import {createContext} from 'react';

type AiUsageContextType = {
    setAiUsed: (changeRequestId: number) => void,
    cleanAiUsed: (changeRequestId: number) => void,
    checkFeedbackModal: (changeRequestId: number) => boolean,
};

export const AiUsageContext = createContext<AiUsageContextType | undefined>(undefined);
